import PaginationNoneFloating from "../../../components/ui/Content/PaginationNoneFloating";
import React, {useCallback, useEffect, useMemo} from "react";
import LoadingSpinner from "../../../components/ui/LoadingSpinner";
import {useSiren} from "../SirenContext";
import {SearchInput} from "../components/SearchInput";
import {useSearchParams} from "react-router-dom";
import {useAuth} from "../../../context/user";
import {HotlineNumberRow} from "../components/HotlineNumberRow";

import {HotlineNumberListHeader} from "../components/HotlineNumberListHeader";
import {useGetNumbers} from "../hooks/useGetNumbers";


export function HotlineNumberList() {

    const [searchParams, setSearchParams] = useSearchParams();

    const {clientID} = useSiren()

    const {data: paginator, limit, search, setSearch, page, setPage, isLoading, refetch} = useGetNumbers(
        searchParams.get("search") ?? undefined,
        searchParams.get("page") ? Number(searchParams.get("page")) : undefined,
    )


    useEffect(() => {
        setSearchParams((prev) => {
            const newParams = new URLSearchParams(prev)
            newParams.set("page", String(page))
            newParams.set("search", search)
            return newParams
        })
    }, [search, page])

    const changePage = useCallback((page: number) => {
        setPage(page)
    }, [])

    const {isSuperAdmin} = useAuth()

    const disableSearch = useMemo(() => {
        return !clientID

    }, [isSuperAdmin, clientID])

    return (
        <>

            <div className="flex justify-center">
                <div className="w-[400px] max-w-full">
                    <SearchInput initialValue={search} onChange={setSearch} disabled={disableSearch}/>
                </div>
            </div>
            {!disableSearch && (
                <div className="flex flex-col gap-4">

                    <div className="bg-white shadow-md p-4 flex flex-col gap-4 items-center">
                        {isLoading && (
                            <div className="p-8">
                                <LoadingSpinner/>
                            </div>
                        )}
                        {!isLoading && (
                            <>
                                <HotlineNumberListHeader/>
                                {paginator && paginator.results.map((t) => (
                                    <HotlineNumberRow hotlineNumber={t} key={t.id} refetch={refetch}/>
                                ))}
                                <div className={"flex justify-center"}>
                                    {paginator && paginator.totalResults != 0 && (
                                        <PaginationNoneFloating
                                            currentPage={paginator.currentPage}
                                            itemsPerPage={limit}
                                            dataLength={paginator.totalResults ?? 0}
                                            togglePageSelect={changePage}
                                        />
                                    )}

                                </div>

                            </>
                        )}

                    </div>
                </div>
            )}
        </>
    )
}